var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossModal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 0C8.046 0 0 8.046 0 18C0 27.954 8.046 36 18 36C27.954 36 36 27.954 36 18C36 8.046 27.954 0 18 0ZM18 32.4C10.062 32.4 3.6 25.938 3.6 18C3.6 10.062 10.062 3.6 18 3.6C25.938 3.6 32.4 10.062 32.4 18C32.4 25.938 25.938 32.4 18 32.4ZM24.462 9L18 15.462L11.538 9L9 11.538L15.462 18L9 24.462L11.538 27L18 20.538L24.462 27L27 24.462L20.538 18L27 11.538L24.462 9Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossModal);
export default __webpack_public_path__ + "static/media/crossModal.0f345ed9a6440950d43a8cdc21613b98.svg";
export { ForwardRef as ReactComponent };